export const TOKEN_KEY = 'authToken';
export const IDENTITY_KEY = 'identity';
export const REFRESH_KEY = 'refreshToken';
export const PERMISSIONS_KEY = 'permissions';
